import { useEffect, useState } from "react";
import styles from "./TeamMember.module.css";
import useNotification from "../../../hooks/useNotification";
import React from "react";
import { ENTERPRISE, ENTERPRISE_COMPANY } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import { useLocation } from "react-router-dom";
import MemberDetails from "./MemberDetails";
import EnterpriseServices from "../../../services/EnterpriseServices";

const TeamMember = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const location = useLocation();
  const id = location.pathname.split("/")[5]

  const BreadcrumbOptions = [
    {
      title: "Enterprise",
      link: ENTERPRISE,
    },
    {
      title: data.company_name || "Company Name",
      link: ENTERPRISE_COMPANY + location?.pathname?.split("/")?.[3],
    },
    {
      title: data.firstName || "User Name",
    },
  ];

  const fetchUserOverviewData = async (id) => {
    const res = await EnterpriseServices.getMemberById(id);

    if (res) {
      if (res.statusCode === 1) {
        setData(res.data);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  useEffect(() => {

    fetchUserOverviewData(id);
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <div className={styles.page_wrap}>
      <CustomBreadcrumb options={BreadcrumbOptions} />
      <MemberDetails data={data} fetchUserOverviewData={fetchUserOverviewData} loading={loading} />
    </div>
  );
};

export default TeamMember;
